import { Theme, alpha } from "@mui/material/styles";
import type { CSSObject } from "type/tss";
import * as env from "shared/env";
import { baseColors } from "theme";

export const styles = (theme: Theme) =>
	({
		dialogPaper: {
			backgroundColor: "white",
		},
		dialogContent: {
			padding: "1rem 1rem 1.5rem",
			backgroundColor: "white",
		},
		divider: {
			backgroundColor: theme.palette.custom.border,
		},
		fieldLabel: {
			fontSize: "0.875rem",
			color: theme.palette.custom.textSecondary,
			fontWeight: 400,
			fontFamily: theme.typography.fontFamily,
		},
		fieldLabelAsterisk: {
			color: theme.palette.error.main,
		},
		textFieldRoot: {
			backgroundColor: "white",
			borderRadius: 8,
			height: 56,
			"& .MuiOutlinedInput-notchedOutline": {
				borderColor: theme.palette.custom.border,
				borderWidth: 1,
			},
			"&:hover": { backgroundColor: baseColors.gray75 },
			"&:hover .MuiOutlinedInput-notchedOutline": {
				borderColor: alpha(theme.palette.secondary.main, 0.4),
			},
			"&.Mui-focused": { backgroundColor: baseColors.gray75 },
			"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
				borderColor: theme.palette.secondary.main,
				borderWidth: 2,
			},
		},
		textFieldFocused: {},
		textFieldNotchedOutline: {},
		textFieldInput: {
			fontSize: "1rem",
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
		helperText: {
			margin: "0.25rem 0.875rem 0",
			fontSize: "0.75rem",
			color: theme.palette.error.main,
			fontFamily: theme.typography.fontFamily,
		},
		selectInputRoot: {
			backgroundColor: "white",
			borderRadius: 8,
			height: 52,
			"& .MuiOutlinedInput-notchedOutline": {
				borderColor: theme.palette.custom.border,
				borderWidth: 1,
			},
			"&:hover": { backgroundColor: baseColors.gray75 },
			"&:hover .MuiOutlinedInput-notchedOutline": {
				borderColor: alpha(theme.palette.secondary.main, 0.4),
			},
			"&.Mui-focused": { backgroundColor: baseColors.gray75 },
			"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
				borderColor: theme.palette.secondary.main,
				borderWidth: 2,
			},
		},
		selectNotchedOutline: {},
		selectFocused: {},
		selectInput: {
			fontSize: "1rem",
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
